export const dots = (num: number) => Array.from({ length: num }, () => "•").join("")
